export default __webpack_public_path__ + "static/media/closeIcon.498cc732.svg";